import { defineAction } from '~/prix'
import { z } from 'zod'
import communityGardenBeneficiaryFetchAction from './communityGardenBeneficiaryFetch.action.json' with { type: 'json' }
import { communityGardenBeneficiaryObject } from '../../communityGarden/communityGardenBeneficiaryObject'

const communityGardenBeneficiaryFetchDefinition = defineAction({
  ...communityGardenBeneficiaryFetchAction,

  input: z.object({
    id: communityGardenBeneficiaryObject.shape.id,
    includeDeleted: z.boolean().nullish(),
  }),
  output: communityGardenBeneficiaryObject,
})

export default communityGardenBeneficiaryFetchDefinition
